var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex gap-md items-center justify-between w-full p-md pb-sm",
    },
    [
      _c("div", { staticClass: "text-outline dark:text-outline-dark" }, [
        _c(
          "div",
          {
            staticClass:
              "flex flex-col md:flex-row gap-xs typography-headline-1 md:typography-body-2-semibold cursor-pointer",
            class: {
              "text-on-background dark:text-on-background-dark":
                _vm.activeRangeKey === "from",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("select-range-key", "from")
              },
            },
          },
          [
            _c("or-label", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "HITL.agent-ui.search-sessions.date-range-picker.start-date"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n        " + _vm._s(_vm.fromLabel) + "\n      "),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("HITL.agent-ui.search-sessions.date-range-picker.dash")
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex text-outline dark:text-outline-dark" }, [
        _c(
          "div",
          {
            staticClass:
              "flex flex-col md:flex-row gap-xs typography-headline-1 md:typography-body-2-semibold cursor-pointer",
            class: {
              "text-on-background dark:text-on-background-dark":
                _vm.activeRangeKey === "to",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("select-range-key", "to")
              },
            },
          },
          [
            _c("or-label", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t(
                      "HITL.agent-ui.search-sessions.date-range-picker.end-date"
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v("\n        " + _vm._s(_vm.toLabel) + "\n      "),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }